// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"40328628","553":"b8880202","931":"1165db0a"}[chunkId] + ".chunk.js";
};